import React from "react";

const Footer = () => {
  return (
    <footer className="py-3 bg-dark">
      <div className="container">
        <p className="m-0 text-center text-white">
          Copyright &copy; Dirección General de Actividades Cinematográficas
          2025
        </p>
      </div>
    </footer>
  );
};

export default Footer;
